import template from "./entity-contacts.html";
import "./entity-contacts.less";
import {
	some,
	trim,
	keyBy
} from "lodash";
import {
	ENTITY_CONTACTS_GET,
	ENTITY_CONTACTS_CREATE,
	ENTITY_CONTACTS_UPDATE,
	ENTITY_CONTACTS_DELETE,
	ENTITY_CONTACTS_RESTORE
} from "routes.js";
import { NAME_SUFFIX_LIST } from "../../../../../../constants";
import { globs } from "../../../../../../services/globs";
import {
	Any, 
	Pattern 
} from "../../../../../../services/security/actionScopes";

//entity-contacts
export function controller(
	appState,
	api,
	loadingService,
	toastr,
	$uibModal,
	securityService
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.openEditOrCreateEntityContactModal = openEditOrCreateEntityContactModal;
	ctrl.promiseTracker = loadingService.getTracker();
	ctrl.remove = remove;
	ctrl.shouldDisplayContact = shouldDisplayContact;
	ctrl.restore = restore;

	ctrl.canAddPattern = globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode("*").create;
	ctrl.editPattern = globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode("*").update;
	ctrl.editAction = (code) => globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode(code).update;
	ctrl.reactivateOrDeactivateActionScope = 
		new Any([
			new Pattern(globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode("*").deactivate),
			new Pattern(globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode("*").reactivate)
		]);
	ctrl.canDeactivateAction = (code) => globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode(code).deactivate;
	ctrl.canReactivateAction = (code) => globs.entityTypes.byType(ctrl.typeConfig.Code).contacts.byCode(code).reactivate;
	
	ctrl.includeInactive = false;
 
	function onInit() {
		ctrl.form = appState.forms.selected;

		ctrl.suffixOptions = [{ key: "", display: "" }].concat(NAME_SUFFIX_LIST.filter((s) => s.show === true));
		ctrl.suffixMap = keyBy(NAME_SUFFIX_LIST, (s) => s.key);

		load();
	}

	function shouldDisplayContact(contact) {
		return ctrl.includeInactive || contact.IsActive;
	}

	async function load() {
		const entityContacts = await loadingService.watch(api.get(ENTITY_CONTACTS_GET(ctrl.form.Id, ctrl.entity.Id)));

		ctrl.Contact = null;
		ctrl.Contacts = entityContacts.map((contact) => {
			contact.$Id = contact.Contact.Id;

			return contact;
		});

		ctrl.entity.Contacts = ctrl.Contacts.map(contact => ({
			Id: contact.Contact.Id,
			Type: contact.Type,
			Name: contact.Name,
			IsActive: contact.IsActive
		}));

		ctrl.hasInactive = some(ctrl.entity.Contacts, i => !i.IsActive);
	}

	async function saveContact(selectedFormId, contact) {
		const request = {
			Contact: {
				Title: contact.Title,
				FirstName: trim(contact.FirstName),
				MiddleName: trim(contact.MiddleName) || null,
				LastName: trim(contact.LastName),
				Suffix: trim(contact.Suffix) || null,
				DateOfBirth: contact.DateOfBirth
			},
			Type: {
				Code: "CAPTAIN"
			}
		};

		const result = await (ctrl.Contact.Id
			? ctrl.put(ENTITY_CONTACTS_UPDATE(selectedFormId, ctrl.entity.Id, ctrl.Contact.Id), request)
			: ctrl.post(ENTITY_CONTACTS_CREATE(selectedFormId, ctrl.entity.Id), request));

		return result;
	}

	async function openEditOrCreateEntityContactModal(contact = { Contact: {} }) {
		ctrl.Contact = { ...contact, Contact: { ...contact.Contact } };
		const canEditContacts = securityService.isPatternAllowed(ctrl.editPattern);

		try {
			const entityContact = await $uibModal.open({
				component: "entity-contact-modal",
				size: "sm",
				backdrop: "static",
				resolve: {
					contact: () => ctrl.Contact.Contact,
					isReadonly: () => !canEditContacts
				}
			}).result;

			await loadingService.watch(saveContact(ctrl.form.Id, entityContact));
			
			const displayName = entityContact.Name ?? `${entityContact.FirstName} ${entityContact.LastName}`;
			await toastr.success(`${displayName} ${ctrl.Contact.Id ? "updated" : "created"} successfully.`);

			await load();
		}catch(err) {
			// no response needed here
		}

	}

	async function remove(contact) {
		await loadingService.watch(ctrl.put(ENTITY_CONTACTS_DELETE(ctrl.form.Id, ctrl.entity.Id, contact.Id)));
		await toastr.success(`${contact.Name} deleted successfully.`);

		await load();
	}

	async function restore(contact) {
		await loadingService.watch(ctrl.put(ENTITY_CONTACTS_RESTORE(ctrl.form.Id, ctrl.entity.Id, contact.Id)));
		await toastr.success(`${contact.Name} restored successfully.`);

		await load();
	}
}

export default angular
	.module("vesl.components.entity-contacts", [])
	.component("entityContacts", {
		controller,
		template,
		bindings: {
			entity: "=",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	}).name;
